export default __webpack_public_path__ + "static/smoke3-c4313625b113de65e9360e5f0a51b403.png";